export default {
  meta: {
    title: '城市档案',
    url: '/cityarchives', //  埋点字段，上报归属的模块
    urlName: '城市档案' //  埋点字段，上报归属的模块
  }
};
